import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useMutation, useQueryClient } from "react-query";
import { Modal, Button } from "rsuite";
import apiClient from "../../libraries/ApiClient";
import { useContext } from "react";
import { ModelContext } from "../../contexts/ModelContext";

const Container = styled.svg`
  cursor: pointer;
  &:hover {
    fill: #1570ef;
    path {
      fill: #fff;
    }
  }
`;

function Patient_CheckReferral_CheckRegular({
  rowId,
  code,
  time,
  caseCode,
  hospital,
}) {
  const queryClint = useQueryClient();
  const [token, setToken] = useState("");
  const [Case, setCase] = useState("");
  const {
    setOpenAskSaveModel,
    changeData,
    openSecondModel,
    setOpenSecondModel,
    openSecondModelName,
    setOpenSecondModelName,
  } = useContext(ModelContext);

  const handleOpen = () => {
    console.log(changeData);
    setOpenSecondModelName("Patient_CheckReferral_CheckRegular");
    setCase(caseCode);
    if (changeData) {
      setOpenAskSaveModel(true);
    } else {
      setOpenSecondModel(true);
    }
  };

  const open = () => {
    console.log(openSecondModel);
    return (
      openSecondModel &&
      openSecondModelName === "Patient_CheckReferral_CheckRegular" &&
      Case == caseCode
    );
  };
  const handleClose = () => setOpenSecondModel(false);
  // console.log(code);

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
  }, []);

  const sendCheckData = async ({ rowId, code, token }) => {
    const data = {
      Data: {
        RowId: rowId,
        Code: code,
        Value: 1,
        Content: "",
      },
    };


    const res = await apiClient.postAes(
      "api/referral/SetPatientStatus/Security",
      data
    );

    return res;
  };

  const {
    data: checkData,
    mutate,
    isLoading,
  } = useMutation(sendCheckData, {
    onSuccess() {
      alert("更新成功");
      //queryClint.invalidateQueries("getListData");
      window.location.reload(true);
    },
  });
  //console.log(checkData);

  return (
    <>
      <span style={{ padding: "5px" }} onClick={handleOpen}>
        <Container
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            rx="2.5"
            stroke="#057AFF"
          />
          <path
            d="M17.7489 8.23434C18.0837 8.54679 18.0837 9.05421 17.7489 9.36666L10.8925 15.7657C10.5577 16.0781 10.0141 16.0781 9.67928 15.7657L6.25109 12.5662C5.9163 12.2537 5.9163 11.7463 6.25109 11.4338C6.58587 11.1214 7.12956 11.1214 7.46435 11.4338L10.2872 14.0659L16.5383 8.23434C16.8731 7.92189 17.4168 7.92189 17.7516 8.23434H17.7489Z"
            fill="#057AFF"
          />
        </Container>
      </span>
      <Modal
        open={open()}
        onClose={handleClose}
        backdrop="static"
        overflow={true}
      >
        <Modal.Header>
          <Modal.Title>確認轉診</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            // height: "200px",
            display: "flex",
            flexDirection: "column",
            height: "100vh",
          }}
        >
          <div style={{ fontSize: "14px", lineHeight: "28px" }}>
            本院目前可接收「{time}
            {hospital}提報取栓轉診(收案編號{caseCode}
            )」病人進行取栓治療。請跟家屬解釋：到院需再做MRI或CTA評估是否大血管阻塞，才會進行取栓手術。取栓可能的風險有麻醉風險、CKD患者腎功能惡化、心肺疾病者拔管困難等（嚴重者需要氣切）。取栓手術可增加神經功能恢復機會，但不保證病人一定能復原，復原不理想者仍可能癱瘓臥床。若家屬同意，可轉院進行取栓評估，務必請主要決策家屬陪同，並請貴院急診協助以下前置作業：
            <div style={{ padding: "16px" }}>
              <p>1. 完成院際轉診交班</p>
              <p>2. 先換病人服</p>
              <p>3. 左手打20號IC</p>
              <p>4. 放置尿管</p>
            </div>
          </div>
          <div
            style={{ fontSize: "14px", display: "flex", alignItems: "center" }}
          >
            經院確認:
            <span style={{ fontSize: "28px", color: "#159895" }}>「轉診」</span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              mutate({ rowId, code, token });

            }}
            disabled={isLoading}
            appearance="primary"
          >
            {isLoading ? "資料傳送中" : "確認"}
          </Button>
          <Button onClick={handleClose}>取消返回</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Patient_CheckReferral_CheckRegular;
